import React from "react";

import { useFetch } from "Hooks/useFetch";

export const SegmentationContext = React.createContext({
  getProjects: async () => {},
  getUsers: async () => {},
});

const SegmentationProvider = ({ children }) => {
  const { fetchData } = useFetch();

  const getProjects = async (setProjects, selectedProjects) => {
    const limit = 10;
    let offset = 0;
    let result_length = 10;

    let projects = [];

    const onSuccessCallback = (data) => {
      const filteredProjects = data.projects.filter(
        (project) =>
          !selectedProjects.find(
            (projectInList) => projectInList.id === project.id,
          ),
      );

      setProjects((prev) => [
        ...prev,
        ...selectedProjects,
        ...filteredProjects,
      ]);
    };

    while (result_length >= limit) {
      const response = await fetchData({
        method: "post",
        path: "/projects/list-projects",
        onSuccessCallback,
        queryParams: { limit, offset },
      });

      offset += limit;
      result_length = response?.data?.projects?.length;

      if (result_length) projects = [...projects, ...response.data.projects];
    }

    return projects;
  };

  const getUsers = async (setUsers, selectedUsers) => {
    const limit = 10;
    let offset = 0;
    let result_length = 10;

    let users = [];

    const onSuccessCallback = (data) => {
      const filteredUsers = data.users.filter(
        (user) =>
          !selectedUsers.find((userInList) => userInList.id === user.id),
      );

      setUsers((prev) => [...prev, ...selectedUsers, ...filteredUsers]);
    };

    while (result_length >= limit) {
      const queryParams = { limit, offset };

      const response = await fetchData({
        method: "get",
        path: "/users/simple-list-users",
        onSuccessCallback,
        queryParams,
      });

      offset += limit;
      result_length = response?.data?.users?.length;

      if (result_length) users = [...users, ...response.data.users];
    }

    return users;
  };

  const contextValue = { getProjects, getUsers };

  return (
    <>
      <SegmentationContext.Provider value={contextValue}>
        {children}
      </SegmentationContext.Provider>
    </>
  );
};

export default SegmentationProvider;
